<template>
  <div v-if="profile" class="d-flex">
    <div class="user-name-profile bg-teacherGold font-m position-relative">
      <img :src="profile" class="profile circle"/>
      <span v-if="!owner" class="crown d-flex justify-content-center align-items-center">
        <img src="@/images/mission/crown.svg" alt="" class="w-18 h-18"></span>
    </div>

  </div>
  <div v-else class="d-flex font-m position-relative">
    <div
        class="profile-no-image"
        :style="`background-color:${backgroundColor};`"
    >
      <slot></slot>
    </div>
    <span v-if="!owner" class="crown d-flex justify-content-center align-items-center">
        <img src="@/images/mission/crown.svg" alt="" class="w-18 h-18 min-w-18 min-h-18"></span>
  </div>
</template>

<script>
/**
 * 회원 프로필 이미지 컴포넌트(member profile image Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
  props: ["profile", "owner", "memberId"],
  data() {
    return {
      arrBackgroundColors: [
        "#fc5356",
        "#7d61d8",
        "#4d9fd6",
        "#40bca7",
        "#9db82f",
        "#df8830",
        "#a967d4",
        "#696481",
        "#4c438d",
        "#fe7947",
      ],
      backgroundColor: "#fc5356",
    };
  },
  mounted() {
    this.backgroundColor = this.arrBackgroundColors[String(this.memberId)[0]];
  },
};
</script>
